document.addEventListener('DOMContentLoaded', () => {
	let galleryCTAs = document.querySelectorAll('.gallery-marquee')

	galleryCTAs.forEach(section => {
		let sliders = section.querySelectorAll('.keen-slider')

		for (let i = 0; i < sliders.length; i++) {
			let speed = i == 0 ? 12000 : i == 1 ? 15000 : 20000
			let duration =
				sliders[i].querySelectorAll('.keen-slider__slide').length * speed
			createPortfolioSlider(
				sliders[i],
				{ duration: duration, easing: linear },
				i == 1 || i == 3 ? true : false
			)
		}
	})

	function linear(x) {
		return x
	}

	function createPortfolioSlider(element, animationOptions, reverseDirection) {
		let maxIdx = null
		new KeenSlider(element, {
			vertical: false,
			loop: true,
			renderMode: 'precision',
			mode: 'free',
			slides: { perView: 'auto', spacing: 16 },
			created(s) {
				maxIdx = s.track.details.slides.length - 1
				if (reverseDirection) {
					maxIdx = -maxIdx
				}
				s.moveToIdx(maxIdx, true, animationOptions)
			},
			updated(s) {
				s.moveToIdx(s.track.details.abs + maxIdx, true, animationOptions)
			},
			animationEnded(s) {
				s.moveToIdx(s.track.details.abs + maxIdx, true, animationOptions)
			},
		})
	}
})
